<template>
  <div class="studentDetail">
    <header class="header-box" v-if="topInfo.aliasName!==''">
      <div class="header-l">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'managementclass' }">
            {{$t('managementV2.classManagement')}}</el-breadcrumb-item>
          <el-breadcrumb-item
                              :to="{ name: 'classdetail', query: { key: $Base64.encode(JSON.stringify({id: queryData.classId}))} }">
            {{$t('managementV2.classDetails')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('managementV2.student')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="student-info">
          <img :src="imgUrl" alt="">
          <div class="info-box">
            <div class="name">
              <el-tooltip :disabled="topInfo.aliasName&&topInfo.aliasName.length<=20" effect="dark"
                          :content="topInfo.aliasName" placement="top-start"><span
                      v-if="!isupdate">{{ topInfo.aliasName | textHiddenTail(20)}}</span>
                <el-input v-model="formAliasName" size="smail" @input="changeInput" minlength="1"
                          maxlength="50" v-else @blur="changeBlurName">
                </el-input>
              </el-tooltip>
              <i @click="editorAliasname" v-if="!isupdate"></i>
            </div>

            <ul class="info">
              <!-- 学号 -->
              <li>
                <span
                      class="lable">{{$t('managementV2.studentNo')}}&nbsp;:</span>&nbsp;&nbsp;{{topInfo.cardNo||"--"}}
                <i></i>
              </li>
              <li>
                <span
                      class="lable">{{$t('managementV2.phone')}}&nbsp;:</span>&nbsp;&nbsp;{{topInfo.loginPhone||"--"}}
                <i></i>
              </li>
              <li>
                <span
                      class="lable">{{$t('managementV2.email')}}&nbsp;:</span>&nbsp;&nbsp;{{topInfo.email||'--'}}
                <i></i>
              </li>
              <li>
                <span
                      class="lable">{{$t('managementV2.average')}}&nbsp;:</span>&nbsp;&nbsp;{{topInfo.averageScore||0}}
                <i></i>
              </li>
              <li>
                <span
                      class="lable">{{$t('managementV2.numberOfJobsCompleted')}}&nbsp;:</span>&nbsp;&nbsp;{{topInfo.finishTaskCount||0}}
                <i></i>
              </li>
              <!-- <li>
                <span
                      class="lable">{{$t('managementV2.joiningTime')}}&nbsp;:</span>&nbsp;&nbsp;{{topInfo.joinTime}}
                <i></i>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
      <div class="header-r">
        <el-button @click="handlerDownload" size="small" class="exportBtn">
          {{$t('jobManagementV2.report')}}
        </el-button>
        <el-button v-if="false" @click="handlerDelete" size="small" class="deletBtn">{{$t('common.del')}}
        </el-button>
      </div>
    </header>
    <main class="student-content">
      <el-table border height="100%" :show-header="false" :data="homeworkList"
                :expand-row-keys="expandRowKeys" row-key="createTime" @row-click="handleRowClick">
        <el-table-column align="left" class-name="createTime">
          <template slot-scope="{ row }">{{$moment(row.createTime).format("YYYY-MM-DD")}}</template>
        </el-table-column>
        <el-table-column align="left" type="expand">
          <template slot-scope="{ row }">
            <ul>
              <li v-for="item in row.homeworkList" :key="item.id">
                <div class="homework-top">
                  <el-tooltip :disabled="item.taskName&&item.taskName.length<=10" effect="dark"
                              :content="item.taskName" placement="top-start">
                    <div class="homework-title">{{item.taskName | textHiddenTail(20)}}
                      <span v-if="statusFormat(item, 2)"
                            :class="`homework-status status-${statusFormat(item, 1)}`">{{statusFormat(item, 2)}}</span>
                    </div>
                  </el-tooltip>
                  <div class="homework-tip" v-if="statusFormat(item, 1) === 1">
                    {{$t('managementV2.awaitTeaher')}}</div>
                  <div class="homework-tip" v-if="statusFormat(item, 1) === 3">
                    {{$t('managementV2.adjustmentSubmit')}}</div>
                  <div class="homework-tip homework-score" v-if="statusFormat(item, 1) === 4">
                    {{item.manualScore||0}}{{$t('managementV2.branch')}}</div>
                </div>
                <div class="homework-desc">
                  <div class="desc-left">
                    <div>
                      {{$i18n.locale === 'zh' ? item.langDesc.replace('>', ' — ') : `${$langCase[item.sourceLang]} — ${$langCase[item.targetLang]}`}}
                    </div>
                    <div>{{$i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode]}}
                    </div>
                    <div class="homework-progress">
                      <el-progress :percentage="item.progress"></el-progress>
                    </div>
                  </div>
                  <div class="desc-right">
                    <div>{{$t('managementV2.teacher')}}：<span>{{item.userName}}</span>
                    </div>
                    <div>{{$t('assignTaskV2.deadLine')}}：<span>{{item.limitTime}}</span></div>
                  </div>
                </div>
                <div class="homework-action">
                  <!-- 查看 -->
                  <el-tooltip effect="dark" :content="$t('common.view')" placement="top">
                    <div class="icon-preview" @click="handleDetail(item)"></div>
                  </el-tooltip>
                  <!-- 下载： 已提交 1、已完成 4 -->
                  <el-tooltip effect="dark" :content="$t('homeworkManage.downloadJob')" placement="top">
                    <div class="icon-download" v-if="statusFormat(item, 1) != 4" @click="handleDownload(item)"></div>
                  </el-tooltip>
                  <!-- <div class="icon-upload" v-if="statusFormat(item, 1) !== 4"
                       @click="handleUpload(item)"></div> -->
                </div>
              </li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <footer>
      <div class="homework-pagination">
        <!-- <el-pagination background layout="prev, pager, next, sizes" :pager-count="5"
                       :current-page="params.page" :page-sizes="[20, 30, 40]"
                       :page-size="params.rows" :total="totalRows" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination> -->
      </div>
    </footer>
    <!-- 删除弹窗 -->
    <delete-dialog :deleteVisible="deleteVisible" @handlerdeleteClose="handlerdeleteClose"
                   :deletTips="deletTips" :deleteType="deleteType" :deleteIdList="deleteIdList"
                   @handlerdeleteSuccess="handlerdeleteSuccess">
    </delete-dialog>
    <!-- 打开下载-->
    <task-upload :visible="uploadVisible" :taskInfo="taskInfo" @handleCancel="handleUploadCancel">
    </task-upload>
    <!-- 导出学生报告 -->
    <async-download-file :isDownloadLoading="isDownloadLoading" :asyncDownloadFun="asyncDownloadFun"
                         @handleClose="handleDownloadClose"></async-download-file>
  </div>
</template>
<script>
import { mapState } from "vuex";
import deleteDialog from "@/views/managements/components/deleteDialog";
import { updateClassUserName, queryClassUserName, batchdownloadStudentreport } from "@/services/managements"
import { queryPageHomework, outLineEditDownload } from '@/services/jobManagement';
import { apiRoot } from "@/services/ajax.js";
import AsyncDownloadFile from '@/components/async-download-file';
// import moment from 'moment';
import TaskUpload from '@/views/my-homework/components/task-upload';
export default {
  name: "studentDetail",
  data() {
    return {
      queryData: {},
      deletTips: "",
      deleteIdList: [],
      deleteType: "",
      deleteVisible: false,
      imgUrl: require('@/views/personCenter/assets/images/user.png'),
      homeworkList: [],
      expandRowKeys: [],
      params: {
        companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
        filter: {
          userId: null,
          companyDepartId: null,
        },
        page: 1,
        rows: 20,
      },
      totalRows: 0,
      uploadVisible: false,
      taskInfo: {},
      isupdate: false,
      topInfo: {},
      formAliasName: "",//修改显示的名字
      isDownloadLoading: false,
      asyncDownloadFun: () => { },
    }
  },
  components: { deleteDialog, TaskUpload, AsyncDownloadFile },
  mounted() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    this.queryClassUserName();
    this.getPageHomework();
  },
  methods: {
    formateContent(value, length) {
      if (value) {
        let str = value && value.toString();
        if (str.length > length) {
          return str.substring(0, length) + '...'
        } else {
          return str
        }
      }
    },
    async changeBlurName() {
      this.isupdate = false;
      let params = {
        id: this.queryData.id,
        name: this.formAliasName,
        companyCode: this.params.companyCode
      }
      if (!this.isupdate) {
        if (this.formAliasName !== this.topInfo.aliasName) {
          const { result, success } = await updateClassUserName(params)
          if (success) {
            this.topInfo.aliasName = result.aliasName;
            this.$message.success(this.$t('managementV2.editorStudentNameSuccess'));
          }
        }
      } else {
        this.formAliasName = this.topInfo.aliasName
      }
    },
    changeInput() {
      this.topInfo.aliasName = this.topInfo.aliasName.replace(/^\s*/g, '');
    },
    //获取学生作业
    async getPageHomework() {
      this.params.filter.userId = this.queryData.userId;
      this.params.filter.companyDepartId = this.queryData.classId
      let { success, list, totalRows } = await queryPageHomework(this.params);
      if (success) {
        this.homeworkList = list;
        this.totalRows = totalRows;
        this.expandRowKeys = list.map(item => item.createTime);
      }
    },
    //获取学生姓名
    async queryClassUserName() {
      let params = {
        id: this.queryData.id,
        classid: this.queryData.classId,
        companyCode: this.params.companyCode
      }
      const { result, success } = await queryClassUserName(params);
      if (success) {
        this.topInfo = result;
      }
    },
    //编辑学生姓名
    editorAliasname() {
      this.isupdate = true;
      this.formAliasName = this.topInfo.aliasName
    },
    //切换每页显示多少条
    handleSizeChange(val) {
      this.params.rows = val;
      this.getPageHomework();
    },
    //切换分页
    handleCurrentChange(val) {
      this.params.page = val;
      this.getPageHomework();
    },
    //作业状态
    statusFormat(item, type) {
      let status = item.finish; // 任务状态
      let scoreStatus = item.scoreStatus;
      if (scoreStatus === 0) {
        switch (status) {
          case 0:
            return type === 1 ? 0 : this.$t('managementV2.notSubmitted');
          case 2:
            return type === 1 ? 2 : this.$t('managementV2.notSubmitted');
          case 1:
            return type === 1 ? 1 : this.$t('managementV2.submitted');
          case 3:
            return type === 1 ? 3 : this.$t('managementV2.returned');
          default:
            break;
        }
      } else if (scoreStatus === 1) {
        switch (status) {
          case 1:
            return type === 1 ? 4 : this.$t('assignTaskV2.complete');
          // default:
          //   return '状态错误'
        }
      }
    },
    handleRowClick(row) {
      if (this.expandRowKeys.includes(row.createTime)) {
        this.expandRowKeys = this.expandRowKeys.filter(i => i !== row.createTime);
      } else {
        this.expandRowKeys.push(row.createTime);
      }
    },
    //跳转编辑器
    handleDetail(row) {
      sessionStorage.setItem("fileName", row.taskName);
      let routeData = this.$router.resolve({
        path: '/neweditor',
        query: {
          key: this.$Base64.encode(JSON.stringify({
            studentId: this.queryData.id,
            classId: this.queryData.classId,
            sourceLang: row.sourceLang,
            targetLang: row.targetLang,
            taskName: row.taskName,
            wordNum: row.sourceWordNum,
            project: 3,
            userId: this.queryData.userId,
            transStatus: 1,
            fileSuffix: row.fileUsableSuffix,
            transModel: row.transModel,
            // 老版参数
            fileId: row.fileId,
            projectId: row.projectId,
            isSplit: true,
            type: 'school',
            taskType: row.taskType,
            taskId: row.id,
            'type-school': 'class-teacher-homework',
            companyCode: row.companyCode,
          })),
        },
      });
      window.open(routeData.href, "_self");
    },
    //下载报告
    async handleDownload(item) {
      let { success, result } = await outLineEditDownload({
        fileId: item.fileId,
        taskId: item.id,
      });
      if (success) {
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = apiRoot(`/common/downloadFile?fileName=${item.taskName + result.substring(result.lastIndexOf("."))}&filePath=${result}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    //导出报告
    handlerDownload() {
      if (parseInt(this.topInfo.finishTaskCount) === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('managementV2.Thenumberofjobscompletedis0Downloadingreportsisnotsupported'));
        return
      }
      let params = {
        companyDepartId: this.queryData.classId,
        userIdList: [this.queryData.userId],
        companyCode: this.params.companyCode
      }
      this.asyncDownloadFun = () => batchdownloadStudentreport(params);
      this.isDownloadLoading = true;
    },
    handleDownloadClose() {
      this.asyncDownloadFun = () => { };
      this.isDownloadLoading = false;
    },
    //打开下载
    handleUpload(item) {
      this.taskInfo = {
        taskId: item.id,
        fileId: item.fileId
      };
      this.uploadVisible = true;
    },
    handleUploadCancel() {
      this.uploadVisible = false;
      this.taskInfo = {};
    },
    //删除学生
    handlerDelete() {
      this.deleteIdList = [];
      this.deleteVisible = true;
      this.deletTips = this.$t("managementV2.Areyousuretodeletethisstudentdata");
      this.deleteType = "student";
      this.deleteIdList.push(this.queryData.id);
    },
    //关闭删除弹窗
    handlerdeleteClose() {
      this.deleteVisible = false;
    },
    //删除成功
    handlerdeleteSuccess() {
      this.deleteVisible = false;
      this.$router.push({
        name: "classdetail",
        query: {
          key: this.$Base64.encode(JSON.stringify({
            id: this.queryData.classId
          }))
        }
      });
    }
  }
}
</script>
<style lang="less" scoped>
@import "./style.less";
</style>